<template>
  <b-modal
    ref="modal"
    size="lg"
    hide-header
    hide-footer
    content-class="m-0 p-0"
    body-class="m-0 p-0">
    <loader class="m-0"></loader>
  </b-modal>
</template>
<script>
export default {
  methods: {
    show() {
      return this.$refs.modal.show();
    },

    hide() {
      return this.$refs.modal.hide();
    },
  }
};
</script>
